import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const gradient = 'linear-gradient(128deg, #ff5858 7%, #f09819 100%)';

export const Highlight = styled.span<{
  children: ReactNode;
}>`
  position: relative;
  z-index: 0;
  display: inline-block;
  background: ${gradient};
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    left: -4px;
    right: -4px;
    bottom: -2px;
    height: 10px;
    background: ${gradient};
    opacity: 0.35;
    border-radius: 6px;
    transform: rotate(-1deg);

    @media ${({ theme }) => theme.media.tablet} {
      bottom: 2px;
    }
  }
`;

export const outline = css`
  outline: 1px solid ${({ theme }) => theme.palette.primary};
  outline-offset: 3px;
`;

export const boxShadow = '0px 0px 17px -3px #FF5858';

export const cardBackround = css`
  border-radius: 6px;
  background: white;
  border: 1px solid ${({ theme }) => theme.palette.lightGray};
`;

export const button = css`
  font-family: Roboto, Helvetica, sans-serif;
  font-weight: 700;
  background: ${gradient};
  color: white;
  border-radius: 40px;
  padding: 11px 34px;
  font-size: 16px;
  border: none;
  letter-spacing: 0.5px;
  outline-color: ${({ theme }) => theme.palette.primary};
  outline-offset: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: ${boxShadow};
    transition: all 0.2s ease;
  }
`;
